import { Controller } from "@hotwired/stimulus";

// Animates the ring fill with the Web Animations API rather than a CSS transition: the
// element is replaced whole on each websocket update, and a transition won't fire on a
// freshly-inserted node that's already at its target.
export default class extends Controller {
  static targets = ["fill"];
  static values = {
    from: { type: Number, default: 0 },
    to: { type: Number, default: 0 },
    duration: { type: Number, default: 1800 },
    circumference: Number,
  };

  connect() {
    const offset = (value) => this.circumferenceValue * (1 - value);

    this.fillTarget.animate(
      [
        { strokeDashoffset: offset(this.fromValue) },
        { strokeDashoffset: offset(this.toValue) },
      ],
      { duration: this.durationValue, easing: "ease-out", fill: "forwards" },
    );
  }
}
